import React from "react";

// Display-only excerpts; never infer equivalence or amendment status.
export function precedentIdentity(item = {}) {
  const title = String(item.title || item.label || "");
  const desc = String(item.description || item.desc || "").replace(/\s+/g, " ").trim();
  const product = item.product_no || item.model_no || title.match(/\((\d{6,14})\)/)?.[1];
  const ref = item.ref_no || item.refNo;
  const percentage = "(?:약\\s*)?\\d+(?:\\.\\d+)?(?:\\s*[~–-]\\s*\\d+(?:\\.\\d+)?)?\\s*%";
  const total = desc.match(new RegExp(`^(.{1,40}?)\\[[^\\]]+\\]\\s*(${percentage})`));
  const first = desc.match(new RegExp(`^([^%]{1,90}?${percentage})`));
  const composition = total ? `${total[1].trim()} ${total[2]}` : first?.[1];
  const a = item.amendment;
  const changed = item.status === "superseded";
  const status = changed
    ? a?.integrity_status === "matched" && a.hs_after ? `변경 → ${a.hs_after}`
      : a?.integrity_status === "revoked" ? "결정 폐지" : "변경 · 연결 확인 중"
    : "변경이력 미확인";
  return { product, ref, composition, status, changed };
}

export default function PrecedentIdentity({ item }) {
  const info = precedentIdentity(item);
  return <div style={{ marginTop: 5, fontSize: 11.5, lineHeight: "17px", color: "var(--audit-text-muted)", overflowWrap: "anywhere" }}>
    {(info.product || info.ref) && <div style={{ display: "flex", flexWrap: "wrap", gap: "2px 8px", color: "var(--audit-text)", fontWeight: 650 }}>
      {info.product && <span>제품표기 {info.product}</span>}
      {info.ref && <span>{info.ref}</span>}
    </div>}
    {info.composition && <div title={item.description || item.desc}>성분: {info.composition}</div>}
    <div style={{ color: info.changed ? "#975a00" : "var(--audit-text-faint)", fontWeight: info.changed ? 650 : 400 }}>{info.status}</div>
  </div>;
}
